export default {"src":"/_next/static/media/bg_blue_m.c2288c93.svg","height":725,"width":639,"blurWidth":0,"blurHeight":0};